import { useCallback, useMemo } from 'react';

import { useHistory } from 'react-router-dom';

import { createOrderDetailsReturnPathname } from '../routing';
import { NewReturnFulfillmentId, NewEnhancedReturnIdPrefix } from './use-pending-return';

export const useReturnNavigation = () => {
  const history = useHistory();

  const createPath = useCallback(
    (salesOrderId, returnId, storeSupportsEnhancedReturns = false) => {
      const currentSearch = history.location.search;
      const currentPathname = history.location.pathname;
      const newPathname = createOrderDetailsReturnPathname(currentPathname, salesOrderId, returnId, storeSupportsEnhancedReturns);

      return `${newPathname}${currentSearch || ''}`;
    },
    [history],
  );

  const createPendingEnhancedReturnPlaceholderId = useCallback((returnId) => {
    return returnId ? `${NewEnhancedReturnIdPrefix}${returnId}` : NewReturnFulfillmentId;
  }, []);

  const navigateToReturn = useCallback(
    (salesOrderId, returnId, storeSupportsEnhancedReturns = false) => {
      history.push(createPath(salesOrderId, returnId, storeSupportsEnhancedReturns));
    },
    [history, createPath],
  );

  return useMemo(() => {
    return {
      createPath,
      navigateToReturn,
      createPendingEnhancedReturnPlaceholderId,
    };
  }, [createPath, navigateToReturn, createPendingEnhancedReturnPlaceholderId]);
};
